/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_PersonalInputs */

const cs_billing_personal = /** @type {(inputs: Billing_PersonalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Osobní dostupně`)
};

const en_billing_personal = /** @type {(inputs: Billing_PersonalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal available`)
};

/**
* | output |
* | --- |
* | "Personal available" |
*
* @param {Billing_PersonalInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const billing_personal = /** @type {((inputs?: Billing_PersonalInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_PersonalInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_billing_personal(inputs)
	return cs_billing_personal(inputs)
});